import React from 'react';
import '../../App.css';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Link } from "react-router-dom"; 
import axios from 'axios';

const styles = {
  bottom_bar: {
    marginTop: 24,
    backgroundColor: '#FAFAFA',
    boxShadow: "none", 
    borderTop: "2px solid #E0E0E0"
  },
  bottom_bar_title_text: {
    fontFamily: 'Open Sans',
    fontSize: 18,
  },
  bottom_bar_text: {
    fontFamily: 'Open Sans',
    fontSize: 18,
    marginBottom: -10,
  },
};

class BottomBarOptions extends React.Component {

    render(){
      const {classes} = this.props
      
        return (
            <Grid className={classes.bottom_bar}>
            <Grid container direction="row" justify="space-evenly" alignItems="center" style={{paddingTop: '2%', paddingBottom: '2%'}}>
              <Grid>
                <b className={classes.bottom_bar_title_text}>Company</b>
                <Link to={{pathname: "/about", state: { prevPath: 'Privacy Policy | CanaWho' }}} style={{ color: 'black', fontFamily: 'Open Sans', textDecoration: 'none'}}>
                <p className={classes.bottom_bar_text}>About Us</p>
                </Link>
                <p className={classes.bottom_bar_text}>Contact</p>
              </Grid>
              <Grid>
                <b className={classes.bottom_bar_title_text}>Legal</b> 
                <Link to={{pathname: "/policy", state: { prevPath: 'Privacy Policy | CanaWho' }}} style={{ color: 'black', fontFamily: 'Open Sans', textDecoration: 'none'}}>
                  <p className={classes.bottom_bar_text}>Privacy Policy</p>
                </Link>
                <Link to={{pathname: "/policy", state: { prevPath: 'Terms of Service | CanaWho' }}} style={{ color: 'black', fontFamily: 'Open Sans', textDecoration: 'none'}}>
                  <p className={classes.bottom_bar_text}>Terms of Service</p>
                </Link>
              </Grid>
            </Grid>
          </Grid>
        );
    }
}

BottomBarOptions.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BottomBarOptions);